/// <amd-module name="Widgets/Configs/PullrequestWidgetConfig/index" />
export * from "./PullRequestWidgetConfig";
